import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { HousekeeperTasksStoreEffects } from './effects';
import { housekeeperTasksReducer } from './reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('housekeeperTasks', housekeeperTasksReducer),
    EffectsModule.forFeature([HousekeeperTasksStoreEffects]),
  ],
})
export class HousekeeperTasksStoreModule {}
